import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { EasypayEmployeeMapping } from '../../easypay-employee-mappings/easypay-employee-mapping.interface';

export class EasypayEmployeeMappingService {
   async getEasypayEmployeeMappings(easypayImportFileId: number, query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<EasypayEmployeeMapping>>(
         `/easypay-import-files/${easypayImportFileId}/easypay-employee-mappings`,
         { params: { ...query } },
      );
      return response.data;
   }

   async getEasypayEmployeeMapping() {
      throw Error('Method not implemented');
   }

   async postEasypayEmployeeMapping() {
      throw Error('Method not implemented');
   }

   async putEasypayEmployeeMapping() {
      throw Error('Method not implemented');
   }

   async deleteEasypayEmployeeMapping() {
      throw Error('Method not implemented');
   }
}
